"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIdentifier = void 0;
const identifierRegExp = new RegExp("^([-_\\p{Letter}][-_\\p{Letter}0-9]*)$", "u");
function isIdentifier(text) {
    return identifierRegExp.test(text);
}
exports.isIdentifier = isIdentifier;
//# sourceMappingURL=isIdentifier.js.map